import { cn } from "@gigpro/ui/tailwind/cn";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

const variants = cva("block shrink-0 animate-pulse rounded-md bg-medium-gray", {
  variants: {
    variant: {
      text: "scale-y-75 before:content-space",
      circle: "aspect-square rounded-full",
      rounded: "scale-y-75",
      rectangular: "",
    },
  },
});

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof variants> {}
function Skeleton({ className, variant = "text", ...props }: Readonly<SkeletonProps>) {
  return <span className={cn(variants({ variant }), className)} {...props} />;
}

export { Skeleton };
